<template>
  <v-app>

    <AppDrawer></AppDrawer>

    <Toolbar></Toolbar>

    <v-content>

      <transition name="slide-x">
        <router-view></router-view>
      </transition>
    </v-content>

<!--    <v-footer app :inset="true" style="z-index: 9999999" max-height="200" class="overflow-y-auto">-->
<!--      <v-layout>-->
<!--        <v-flex>-->
<!--          <pre>{{$store.state.route}}</pre>-->
<!--        </v-flex>-->
<!--        <v-flex>-->
<!--          <pre>{{selectedService}}</pre>-->
<!--        </v-flex>-->
<!--      </v-layout>-->
<!--    </v-footer>-->

  </v-app>
</template>

<script>
import AppDrawer from '@/components/layout/AppDrawer';
import Toolbar from '@/components/layout/Toolbar';

const name = 'App';

export default {

  name,

  components: {
    AppDrawer,
    Toolbar,
  },

  data: () => {
    return {};
  },

  created() {
    this.$store.dispatch('getServiceAreas');
    this.$store.dispatch('getProviders');  },

  computed: {

    // selectedService() {
    //   return this.$store.getters.selectedService;
    // },

  },

};
</script>
